import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import classNames from 'classnames'
import { Image } from 'components/qstrap'
import Button from 'components/atoms/Button'
import Typography from 'components/atoms/Typography'

const ctaLink = (kind) => {
  switch (kind) {
    case 'schools': return '/directory'
    case 'studyFields': return '/majors'
    case 'professions': return '/careers'
    case 'scholarships': return '/scholarships'
    default: return '/'
  }
}

const ThumbnailEmpty = ({ kind, className }) => {
  const kindTranslated = intl.get(`molecules.ThumbnailEmpty.kind.${kind}`)
  const imgExt = kind === 'scholarships' ? 'svg' : 'png'
  if (kind === 'scholarships-directory') {
    return (
      <div className="ThumbnailEmpty text-center">
        <Typography variant="subheading" className="ThumbnailEmpty__top-text" component="div">
          Saat ini belum ada beasiswa dengan kategori tersebut
        </Typography>
      </div>
    )
  }
  return (
    <div className={classNames('ThumbnailEmpty text-center', className)}>
      <Typography variant="title" className="ThumbnailEmpty__top-text" component="div">
        {intl.get('molecules.ThumbnailEmpty.top_text', { kind: kindTranslated })}
      </Typography>

      <Image className="ThumbnailEmpty__Image" src={`/assets/img/likes/empty-${kind}.${imgExt}`}/>

      <Typography variant="subheading" className="ThumbnailEmpty__bottom-text" component="div">
        <span>{intl.get('molecules.ThumbnailEmpty.bottom_text', { kind: kindTranslated })}</span> ❤️
      </Typography>

      <Button className="ThumbnailEmpty__cta-button" href={ctaLink(kind)}>
        {intl.get('molecules.ThumbnailEmpty.page', { kind: kindTranslated })}
      </Button>
    </div>
  )
}

ThumbnailEmpty.propTypes = {
  kind: PropTypes.oneOf(['schools', 'studyFields', 'professions', 'scholarships']),
  className: PropTypes.string,
}

export default ThumbnailEmpty
